import React from 'react'
import Create from '../crud/create'
import fields from './fields'

const CreateCommentBot = (props) => {
  return (
    <Create
      title='Create Comment Bot'
      fields={fields}
      resource={{
        schedules: [],
        include_not_checked_in_users: false,
        include_checked_in_users: false,
        comment_variations: []
      }}
      apiPath='admin/comment_bots'
      successRedirectPath={resource => `/write-now/comment-bots/${resource.id}/edit`}
    />
  )
}

export default CreateCommentBot
